// extracted by mini-css-extract-plugin
module.exports = {"buttonDisable":"QuestionBtn_buttonDisable__1OdF5","learnButtonLinkColor":"QuestionBtn_learnButtonLinkColor__bx3CT"};